module.exports = __webpack_public_path__ + "img/profile_small.0802095e.png";